import {remCalc} from '_themeUtils'
import sizes from '../primitives/sizes'

const icon = {
    xs: sizes[3.5],
    sm: sizes[4],
    'sm-plus': sizes[4.5], // 18px — modal/drawer close (X) and back (<) icons per Figma (node 5655-4320)
    'share-mobile': remCalc(25), // 25px glyph in the mobile share list; drawn inside the 32px `xl` slot so the layout does not move
    md: sizes[5],
    lg: sizes[6],
    xl: sizes[8],
    7: sizes[7],
    'tile-button': {base: sizes[4], lg: sizes[4.5]},
    pdp: {base: sizes[5], md: sizes[4.5]},
    // Header action icons (search/wishlist/user/cart). Responsive via CSS breakpoints — NOT via
    // useViewport/user-agent — so the SSR HTML is identical for every device and safe to cache on the
    // CDN (avoids the emotion className hydration mismatch). 20px on mobile (base), 16px from lg up,
    // matching the previous md→sm mapping.
    'header-action': {base: sizes[5], lg: sizes[4]},
    xxl: sizes[12],
}

const button = {
    xs: remCalc(176),
    sm: remCalc(272),
    md: remCalc(343),
    none: 'none',
}

const input = {
    height: sizes[13.5],
}

export {icon, button, input}
